import { Box } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

type ScrollableDialogContentProps = {
  children: ReactNode;
  footer: ReactNode;
  maxHeight?: string;
};

export const ScrollableDialogContent = ({
  children,
  footer,
  maxHeight = '70vh',
}: ScrollableDialogContentProps): ReactElement => (
  <Box display="flex" flexDirection="column" sx={{ maxHeight, overflow: 'hidden' }}>
    <Box sx={{ overflowY: 'auto', flex: 1, pt: 1, pb: 1, pr: 1 }}>{children}</Box>
    <Box
      display="flex"
      justifyContent="flex-end"
      gap={1}
      sx={{ pt: 1, borderTop: '1px solid', borderColor: 'divider' }}
    >
      {footer}
    </Box>
  </Box>
);
